import { InjectionToken } from '@angular/core';

/**
 * Blockable Interface
 * To be used on a component when it needs to display
 * some specific behavior when disabled.
 * For instance, when button is clicked on orders (buy/sell)
 * we need to show spinning wheel AND block screen */
export interface Blockable {
  setBlocked(value: boolean): void;
  isBlocked(): boolean;
}

export const BLOCKABLE = new InjectionToken<Blockable>('blockableToken');
